export default __webpack_public_path__ + "static/media/m2.179677a1.png";